import ModalCloseButton from '../../../../Component/UI/ModalCloseButton';
import styled from "styled-components";


interface ExcessOrderItemModalProps {
  visible: boolean;
  handleModal: () => void;
  liveInfo?: { title: string; start: string; end: string };
  excessQty: number;
}

/**
 * 초과 주문건(재고 초과) 단건 팝업 — 수량 칸의 빨간 ! 아이콘 클릭 시 노출.
 * 목업: biz-ttori projects/close/Docs/디자인/초과 주문건 발생_단건팝업.png
 */
const ExcessOrderItemModal = ({
  visible,
  handleModal,
  liveInfo,
  excessQty,
}: ExcessOrderItemModalProps) => {
  const closeModal = () => handleModal();
  const stopPropagation = (e: React.MouseEvent) => e.stopPropagation();

  return (
    <Container style={visible ? {} : { display: "none" }} onClick={closeModal}>
      <ModalBox onClick={stopPropagation}>
        <Title>
          초과 주문건
          <ModalCloseButton tone="admin" aria-label="초과 주문건 닫기" onClick={closeModal} />
        </Title>
        <SubTitle>시스템 오류로 인해 초과된 주문건이 발생하였습니다.</SubTitle>

        <InfoBox>
          <InfoRow>
            <span className="label">라이브 일시</span>
            <span>
              {liveInfo?.start} ~ {liveInfo?.end}
            </span>
          </InfoRow>
          <InfoRow>
            <span className="label">라이브 제목</span>
            <span>{liveInfo?.title}</span>
          </InfoRow>
          <InfoRow>
            <span className="label">초과된 수량</span>
            <span>{excessQty}</span>
          </InfoRow>
        </InfoBox>
      </ModalBox>
    </Container>
  );
};

export default ExcessOrderItemModal;

const Container = styled.div`
  z-index: 100;
  background-color: #00000085;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

const ModalBox = styled.div`
  box-sizing: border-box;
  width: calc(100% - 24px);
  max-width: 400px;
  background-color: var(--admin-theme-surface, white);
  color: var(--admin-ink);
  border-radius: 8px;
  padding: 30px;
  max-height: calc(100dvh - 32px);
  overflow-y: auto;
  overscroll-behavior: contain;
`;

const Title = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  font-family: var(--font-family-base); font-weight: var(--font-weight-semibold);
  img {
    cursor: pointer;
  }
`;

const SubTitle = styled.div`
  margin-top: 8px;
  font-size: 14px;
  color: var(--admin-muted);
  font-family: var(--font-family-base); font-weight: var(--font-weight-regular);
`;

const InfoBox = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const InfoRow = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 14px;
  font-family: var(--font-family-base); font-weight: var(--font-weight-regular);
  span.label {
    width: 90px;
    color: var(--admin-muted);
    flex-shrink: 0;
  }
`;
